<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs headline="Học viên" :link="[{ text: 'Học viên', href: '../students' }]" />
      </div>

      <div class="d-flex">
        <v-btn
          color="primary"
          @click="onClickUpsertReservation()"
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
        <student-list-actions
          v-if="['super_admin', 'education_manager'].includes(role.type)"
          :selected="selected"
          @removed="selected = []"
          :filter="draw"
          @filter="draw = !draw"
        />
      </div>
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-row no-gutters>
        <v-col class="text-right pa-0">
          <span v-if="$vuetify.breakpoint.smAndDown">
            <student-filter-dialog @onFilterChanged="refresh" forReservation />
          </span>
          <!-- <setting-table-header :default-headers="originHeaders" @change="headers = $event" /> -->
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" icon class="ml-2">
                <v-icon>mdi-settings</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense style="width: 200px">
              <v-list-item
                v-show="header.configurable"
                dense
                v-for="header in headers"
                :key="header.value"
              >
                <v-checkbox
                  class="mt-0"
                  hide-details="auto"
                  small
                  :label="header.text"
                  :input-value="header.show"
                  @change="onToggleHeader(header.value, !header.show)"
                ></v-checkbox
              ></v-list-item> </v-list
          ></v-menu>
          <span v-if="$vuetify.breakpoint.mdAndUp">
            <drop-menu>
              <export-excel :custom-header="headers" api="/students/" />
            </drop-menu>
          </span>
        </v-col>
      </v-row>
      <student-filter
        ref="studentFilter"
        v-if="$vuetify.breakpoint.mdAndUp"
        @onFilterChanged="refresh"
        forReservation
      />
      <v-data-table
        :dense="true"
        item-key="id"
        disableSort
        :headers="visibleHeaders"
        :items="tableData"
        hide-default-footer
        :disable-pagination="true"
      >
        <template v-slot:no-data="">Chưa có lần bảo lưu nào </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn icon small @click.stop="onClickUpsertReservation(item)">
              <v-icon v-if="canEdit" small> mdi-pencil</v-icon>
              <v-icon v-else small> mdi-eye</v-icon>
            </v-btn>
            <v-btn v-if="canEdit" icon small @click.stop="onClickDeleteReservation(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.reason_type="{ value }">
          {{ getReasonTypeLabel(value) }}
        </template>
        <template v-slot:item.student.name="{ item }">
          <card-student-name :student="item.student" link />
        </template>
        <template v-slot:item.status="{ value }">
          {{ getReservationStatusLabel(value) }}
        </template>
        <template v-slot:item.tuition_status="{ value }">
          {{ getTuitionStatusLabel(value) }}
        </template>
        <template v-slot:item.start_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.student.dob="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.end_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:item.return_date="{ value }">
          {{ formatDateField(value) }}
        </template>
        <template v-slot:[`item.student.majors`]="{ value }">
          <span v-for="(major, index) in value" :key="major.id">
            {{ major.title }}
            <span v-if="index < value.length - 1">{{ ', ' }}</span>
          </span>
        </template>
        <template v-slot:[`item.student.generation`]="{ value }">
          <span style="white-space: nowrap">{{ value ? value.code : '' }}</span>
        </template>
        <template v-slot:[`item.student.gender`]="{ value }">
          <span style="white-space: nowrap">{{ getGenderLabel(value) }}</span>
        </template>
        <template v-slot:top=""> </template>
      </v-data-table>
      <UpsertReservationDialog
        v-if="upsertReservationDialog.isOpen"
        :isOpen="upsertReservationDialog.isOpen"
        :isEdit="upsertReservationDialog.isEdit"
        :currentItem="upsertReservationDialog.currentItem"
        @close="upsertReservationDialog.onCancel"
        @cancel="upsertReservationDialog.onCancel"
        @confirm="upsertReservationDialog.callback"
      />
    </v-card>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DateSelector from '@/components/basic/DateSelector.vue'
import ExportExcel from '@/components/basic/ExportExcel'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import UpsertReservationDialog from '@/components/UpsertReservationDialog.vue'
import {
  getGenderLabel,
  getPaymentMethodOptions,
  getReasonTypeLabel,
  getReservationStatusLabel,
  getTuitionStatusLabel,
  reasonTypeOptions,
  transformDateForDatePicker,
  tuitionStatusOptions
} from '@/helpers'
import DropMenu from '@/modules/student/menu/Menu.vue'
import SingleStudentListActions from '@/modules/student/SingleStudentListActions'
import StudentFilter from '@/modules/student/StudentFilter'
import StudentFilterDialog from '@/modules/student/StudentFilterDialog'
import StudentListActions from '@/modules/student/StudentListActions'
import StudentNewDialog from '@/modules/student/StudentNewDialog'
import { cloneDeep, get, set, unset } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { getReservationStatus } from '../../helpers'

export default {
  components: {
    UpsertReservationDialog,
    DateSelector,
    AutocompleteStudent,
    BaseDialog,
    CardStudentName,
    DropMenu,
    SingleStudentListActions,
    StudentListActions,
    StudentNewDialog,
    StudentFilter,
    Breadcrumbs,
    SettingTableHeader,
    StudentFilterDialog,
    ExportExcel
  },
  props: {
    role: String
  },
  data() {
    return {
      upsertReservationDialog: {
        currentItem: null,
        isEdit: false,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.isEdit = false
          this.upsertReservationDialog.currentItem = null
        }
      },
      headers: [
        {
          text: 'STT',
          value: 'index',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 56
        },
        {
          text: 'Tên',
          value: 'student.name',
          align: 'left',
          sortable: false,
          show: true,
          configurable: false,
          width: 200
        },
        {
          text: 'Lớp',
          value: 'student.tags',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Chuyên ngành',
          value: 'student.majors',
          align: 'left',
          sortable: false,
          configurable: true,
          show: true,
          width: 400
        },
        {
          text: 'Khóa',
          value: 'student.generation',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày sinh',
          value: 'student.dob',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Giới tính',
          value: 'student.gender',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Bảo lưu lần thứ',
          value: 'reservation_index',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày bắt đầu',
          value: 'start_date',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        {
          text: 'Ngày hết hạn bảo lưu',
          value: 'end_date',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },
        { text: 'Lý do', value: 'reason_type', show: true, configurable: true },
        { text: 'Tình trạng học phí', value: 'tuition_status', show: true, configurable: true },
        { text: 'Trạng thái', value: 'status', show: true, configurable: true },
        {
          text: 'SĐT',
          value: 'student.phone',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Email',
          value: 'student.email',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ngày quay lại dự kiến',
          value: 'return_date',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Ngày quay lại thực tế',
          value: 'actual_return_date',
          align: 'left',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Lớp học mới',
          value: 'new_class',
          align: 'left',
          sortable: false,
          show: false,

          configurable: true
        },
        {
          text: 'Ghi chú',
          value: 'note',
          align: 'left',
          sortable: false,
          show: true,
          configurable: true
        },

        {
          // {
          //   text: 'Loại',
          //   value: 'rootMajor',
          //   align: 'left',
          //   sortable: false,
          //   configurable: true,
          //   show: false
          // },
          // {
          //   text: 'Học Phí',
          //   value: 'tuition',
          //   align: 'left',
          //   sortable: false,
          //   show: false,
          //   configurable: true
          // },
          // {
          //   text: 'Ngày hoàn thành thủ tục bảo lưu',
          //   value: 'process_completion_date',
          //   align: 'left',
          //   sortable: false,
          //   show: true,
          //   configurable: true
          // },
          text: 'Hành động',
          value: 'actions',
          align: 'left',
          sortable: false,
          configurable: false,
          show: true
        }
      ],
      selected: [],
      draw: false,
      search: '',
      loading: false,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      studentTableOptions: {},
      onCreate: false,
      selectedStudent: {}
    }
  },
  async created() {
    this.loadDataOnCreated()
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    ...mapState('reservation', ['reservations']),
    reasonTypeOptions,
    tuitionStatusOptions,
    getPaymentMethodOptions,
    visibleHeaders() {
      return this.headers.filter(i => i.show)
    },

    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    typeQueryParam() {
      return get(this.$route.query, 'type', 'long_term')
    },
    visibleHeaders() {
      return this.headers.filter(i => i.show)
    },
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm bảo lưu'
      }
    },
    tableData() {
      let output = this.reservations.map(({ student, ...o }, index) => ({
        student,
        ...o,
        index: index + 1,
        status: getReservationStatus(o)
      }))

      return output
    }
  },
  methods: {
    ...mapActions('student', ['fetchStudent']),

    ...mapActions('reservation', [
      'fetchReservations',
      'createReservation',
      'updateReservation',
      'removeReservation'
    ]),
    getGenderLabel,
    transformDateForDatePicker,
    getReasonTypeLabel,
    getReservationStatusLabel,
    getReservationStatus,
    getTuitionStatusLabel,

    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onToggleHeader(key, value) {
      this.headers = this.headers.map(i => {
        if (i.value === key) {
          return { ...i, show: value }
        }
        return i
      })
    },
    async refresh(query) {
      unset(query, ['type'])
      unset(query, ['status'])
      this.loading = true
      const {
        _sort,
        start_date_gte,
        start_date_lte,
        end_date_gte,
        end_date_lte,
        reservation_status,
        ...o
      } = query

      const trueQuery = { _sort, start_date_gte, start_date_lte, end_date_gte, end_date_lte }
      Object.entries(o).map(([k, v]) => {
        trueQuery[`student[${k}]`] = v
      })
      switch (reservation_status) {
        case 'returned':
          trueQuery.actual_return_date_lte = moment().endOf('day').toISOString()
          break

        case 'expired':
          if (!trueQuery.end_date_lte || moment().isBefore(trueQuery.end_date_lte)) {
            trueQuery.end_date_lte = moment().endOf('day').toISOString()
          } else {
            trueQuery.end_date_lte = moment(trueQuery.end_date_lte).endOf('day').toISOString()
          }
          break

        case 'waiting':
          if (!trueQuery.start_date_gte || moment().isAfter(trueQuery.start_date_gte)) {
            trueQuery.start_date_gte = moment().startOf('day').toISOString()
          } else {
            trueQuery.start_date_gte = moment(trueQuery.start_date_gte).startOf('day').toISOString()
          }
          break

        case 'active':
          if (!trueQuery.start_date_lte || moment().isBefore(trueQuery.start_date_lte)) {
            trueQuery.start_date_lte = moment().endOf('day').toISOString()
          } else {
            trueQuery.start_date_lte = moment(trueQuery.start_date_lte).endOf('day').toISOString()
          }
          trueQuery['_where[_or][0][end_date_null]'] = true
          if (!trueQuery.end_date_gte || moment().isAfter(trueQuery.end_date_gte)) {
            set(trueQuery, ['_where[_or][1][end_date]'], moment().startOf('day').toISOString())
          } else {
            set(
              trueQuery,
              ['_where[_or][1][end_date_gte]'],
              moment(trueQuery.end_date_gte).startOf('day').toISOString()
            )
          }
          break
        default:
          break
      }
      await this.fetchReservations(trueQuery)
      this.loading = false
    },
    async loadDataOnCreated() {
      // const initialType = get(this.$route.query, 'type', 'long_term')

      await this.fetchReservations({
        // 'student[type]': initialType
      })
    },
    onClickUpsertReservation(item) {
      let data = {
        student: '',
        start_date: moment().startOf('day').toISOString(),
        end_date: undefined,
        process_completion_date: undefined,
        reason: '',
        note: '',
        reason_type: '',
        tuition_status: '',
        new_class: '',
        return_date: undefined,
        actual_return_date: undefined,
        new_class_date: undefined
      }
      if (item) {
        data = cloneDeep(item)
        data.student = data.student.id
      }
      this.upsertReservationDialog.currentItem = data
      this.upsertReservationDialog.isEdit = !!item
      this.upsertReservationDialog.isOpen = true
      this.upsertReservationDialog.callback = (async payload => {
        try {
          if (item) {
            await this.updateReservation({
              id: item.id,
              params: payload
            })
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createReservation({
              params: payload
            })
            this.$alert.success('Tạo thành công')
          }
          await this.fetchStudent(
            this.upsertReservationDialog.currentItem.student.id ||
              this.upsertReservationDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.currentItem = null
        }
      }).bind(this)
    },
    onClickDeleteReservation(item) {
      this.$dialog.confirm({
        title: 'Xóa bảo lưu',
        text: ` Bạn có Chắc Chắn xóa thông tin bảo lưu này?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          await this.removeReservation({ id: item.id })
          this.$alert.success('Xóa thành công')
          await this.fetchStudent(item.student.id)
        }
      })
    }
  },

  watch: {
    typeQueryParam() {
      this.$refs.studentFilter.reset()
      this.loadDataOnCreated()
    }
  }
}
</script>
<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  th:nth-child(2),
  td:nth-child(2) {
    position: sticky;
    left: 56px;
    z-index: 1;
  }
}
</style>
